import React from 'react';

const Company = () => {
    return (
        <div className="min-h-screen flex items-center justify-center">
            <h1 className="text-3xl font-bold">About Our Company</h1>
        </div>
    );
};

export default Company;